import { urls } from '../../referenceData';

export default async () => {
  const res = await fetch(`${urls.apiUrl()}publicviews`);// eslint-disable-line i18next/no-literal-string

  return res.json();
};
